import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";

import {
  ADMINISTRATOR,
  AGENT,
  DIRECTOR,
  FINANCE,
  FINTECH,
  HIGH_MANAGEMENT,
  INFORMATION_AGENT,
  INTERNAL_ROLES,
  MANAGER,
  MENROL_ELIGIBLE_ROLES,
  PLAN_ADMINISTRATOR,
} from "../../../../utils/Roles";
import userHasAccess from "../../../../utils/userHasAccess";
import { MANUAL, RECURRING } from "../enums/billingPeriodTypes";
import { ACTIVE, IMPLEMENTATION, INACTIVE, TERMINATED } from "../enums/clientStatusTypes";
import { buildMENROLFrontendURL } from "../../../../utils/UrlUtils";
import { TED_DESJARDINS } from "../enums/synchronizationOptions";

class ClientNav extends React.Component {
  constructor(props) {
    super(props);
    this.renderMenu = this.renderMenu.bind(this);
    this.isCorporateUser = this.isCorporateUser.bind(this);
    this.getRequiredRoleForClass = this.getRequiredRoleForClass.bind(this);
    this.getRequiredRoleForClientUsers = this.getRequiredRoleForClientCoverages.bind(this);
    this.getExactRoleForBulkSalary = this.getExactRoleForBulkSalary.bind(this);
    this.getRequiredRoleForClientUsers = this.getRequiredRoleForClientUsers.bind(this);
    this.getRequiredRoleForInvoices = this.getRequiredRoleForInvoices.bind(this);
    this.getExactRoleForInvoices = this.getExactRoleForInvoices.bind(this);
    this.getRequiredRoleForGuaranteeConfigurations = this.getRequiredRoleForGuaranteeConfigurations.bind(this);
  }

  isMintAvailable(menu, isMintEnabled) {
    return !menu.requiresMintEnabled || isMintEnabled;
  }

  isMenrolAvailable(menu) {
    if (!menu.requiresMenrolEnabled) {
      return true;
    }
    const { auth, isMenrolEnabled } = this.props;
    const userMenrolStatus = auth && auth.user && auth.user.menrolStatus;
    return isMenrolEnabled && userMenrolStatus === ACTIVE.value;
  }

  isClientStatusTypeValid(menu) {
    if (!menu.exactClientStatusType) {
      return true;
    }
    const { client } = this.props;
    const clientStatus = client && client.clientStatusType;
    return menu.exactClientStatusType.some(status => status.value === clientStatus);
  }

  isValidSyncType(menu) {
    const disabled = menu.disabledSyncType || [];
    const clientSyncType = this.props.client && this.props.client.syncType;
    return !disabled.some(d => d.value === clientSyncType);
  }


  isArchivedClientAllowed(menu) {
    const { client } = this.props;
    const isArchived = client && client.isArchived;
    return menu.includeArchivedClient !== false || !isArchived;
  }

  isBillingPeriodAllowed(menu, clientBillingPeriodType) {
    if (!menu.disabledBillingPeriodType) {
      return true;
    }
    return menu.disabledBillingPeriodType.value !== clientBillingPeriodType;
  }

  hasRequiredRole(menu) {
    const hasRoleInList = userHasAccess(menu.requiredRole);
    const isExactRole = menu.exactRole ? userHasAccess(menu.exactRole, true) : false;
    return hasRoleInList || isExactRole;
  }

  renderMenu(menu, clientBillingPeriodType, shouldRender, isMintEnabled) {
    return (
      this.isMintAvailable(menu, isMintEnabled) &&
      this.isMenrolAvailable(menu) &&
      this.isClientStatusTypeValid(menu) &&
      this.isArchivedClientAllowed(menu) &&
      this.isBillingPeriodAllowed(menu, clientBillingPeriodType) &&
      this.hasRequiredRole(menu) &&
      this.isValidSyncType(menu) &&
      shouldRender
    );
  }

  isCorporateUser(client) {
    const associatedClientIds = JSON.parse(sessionStorage.getItem("associatedClientIds") || "[]");
    if (associatedClientIds.length > 0) {
      return associatedClientIds.includes(client.clientId) && client.clientBillingPeriodType === RECURRING.value;
    }
    return true;
  }

  getRequiredRoleForClass(client) {
    switch (client.clientStatusType) {
      case IMPLEMENTATION.value:
        return PLAN_ADMINISTRATOR;
      case ACTIVE.value:
      case INACTIVE.value:
      case TERMINATED.value:
        return AGENT;
    }
  }

  getRequiredRoleForClientCoverages(client) {
    switch (client.clientStatusType) {
      case IMPLEMENTATION.value:
        return FINANCE;
      case ACTIVE.value:
      case INACTIVE.value:
      case TERMINATED.value:
        return AGENT;
    }
  }
  getRequiredRoleForGuaranteeConfigurations(client) {
    switch (client.clientStatusType) {
      case IMPLEMENTATION.value:
      case ACTIVE.value:
      case INACTIVE.value:
      case TERMINATED.value:
        return HIGH_MANAGEMENT;
    }
  }

  getExactRoleForBulkSalary(client) {
    switch (client.clientStatusType) {
      case IMPLEMENTATION.value:
        return [ADMINISTRATOR, FINTECH, MANAGER, FINANCE, DIRECTOR, PLAN_ADMINISTRATOR];
      case ACTIVE.value:
      case INACTIVE.value:
      case TERMINATED.value:
        return [ADMINISTRATOR, FINTECH, DIRECTOR, MANAGER, PLAN_ADMINISTRATOR];
    }
  }

  getRequiredRoleForClientUsers(client) {
    switch (client.clientStatusType) {
      case IMPLEMENTATION.value:
      case ACTIVE.value:
      case INACTIVE.value:
      case TERMINATED.value:
        return MANAGER;
    }
  }

  getRequiredRoleForInvoices(client) {
    switch (client.clientStatusType) {
      case IMPLEMENTATION.value:
        return PLAN_ADMINISTRATOR;
      case ACTIVE.value:
      case INACTIVE.value:
      case TERMINATED.value:
        return MANAGER;
    }
  }

  getExactRoleForInvoices(client) {
    switch (client.clientStatusType) {
      case IMPLEMENTATION.value:
        return [PLAN_ADMINISTRATOR];
      case ACTIVE.value:
      case INACTIVE.value:
      case TERMINATED.value:
        return [PLAN_ADMINISTRATOR, INFORMATION_AGENT];
    }
  }

  getMenus() {
    const { client, clientAttachmentsCount } = this.props;
    const menus = [
      {
        requiredRole: AGENT,
        exactRole: [INFORMATION_AGENT, PLAN_ADMINISTRATOR],
        to: (clientId) => `/dashboard/clients/${clientId}/members`,
        title: "clients.client.pages.members",
      },
      {
        requiredRole: AGENT,
        exactRole: [INFORMATION_AGENT, PLAN_ADMINISTRATOR],
        to: (clientId) => `/dashboard/clients/${clientId}/divisions`,
        title: "clients.client.pages.divisions",
      },
      {
        requiredRole: this.getRequiredRoleForClass(client),
        to: (clientId) => `/dashboard/clients/${clientId}/classes`,
        title: "clients.client.pages.classes",
      },
      {
        requiredRole: AGENT,
        exactRole: [INFORMATION_AGENT, PLAN_ADMINISTRATOR],
        to: (clientId) => `/dashboard/clients/${clientId}/billingPeriods`,
        title: "clients.client.pages.billingPeriods",
      },
      {
        requiredRole: this.getRequiredRoleForGuaranteeConfigurations(client),
        to: (clientId) => `/dashboard/clients/${clientId}/client-guarantees`,
        title: "clients.client.pages.clientGuarantees",
      },
      {
        requiredRole: this.getRequiredRoleForClientCoverages(client),
        to: (clientId) => `/dashboard/clients/${clientId}/client-coverages`,
        title: "clients.client.pages.coverages",
      },
      {
        requiredRole: this.getRequiredRoleForInvoices(client),
        exactRole: this.getExactRoleForInvoices(client),
        to: (clientId) => `/dashboard/clients/${clientId}/invoices`,
        title: "clients.client.pages.invoices",
      },
      {
        requiredRole: AGENT,
        disabledBillingPeriodType: RECURRING,
        shouldRender: (client) => !!client.shouldImportWithoutId,
        to: (clientId) => `/dashboard/clients/${clientId}/member-identifier`,
        title: "clients.client.pages.memberIdentifier",
      },
      {
        requiredRole: MANAGER,
        exactRole: [PLAN_ADMINISTRATOR],
        shouldRender: this.isCorporateUser,
        to: (clientId) => `/dashboard/clients/${clientId}/reports`,
        title: "clients.client.pages.reports",
      },
      {
        requiredRole: AGENT,
        exactRole: [INFORMATION_AGENT, PLAN_ADMINISTRATOR],
        to: (clientId) => `/dashboard/clients/${clientId}/client-attachments`,
        title: "clients.client.pages.clientAttachments",
        count: clientAttachmentsCount,
      },
      {
        disabledBillingPeriodType: MANUAL,
        exactRole: this.getExactRoleForBulkSalary(client),
        to: (clientId) => `/dashboard/clients/${clientId}/bulk-salaries`,
        title: "clients.client.pages.bulkSalary",
      },
      {
        requiredRole: AGENT,
        exactRole: [PLAN_ADMINISTRATOR],
        disabledBillingPeriodType: MANUAL,
        to: (clientId) => `/dashboard/clients/${clientId}/premium-simulator`,
        title: "clients.client.pages.premiumSimulator",
      },
      {
        requiredRole: this.getRequiredRoleForClientUsers(client),
        to: (clientId) => `/dashboard/clients/${clientId}/users`,
        title: "clients.client.pages.clientUsers",
      },
      {
        requiredRole: MANAGER,
        to: (clientId) => `/dashboard/clients/${clientId}/configurations`,
        title: "clients.client.pages.configurations",
      },
      {
        exactRole: [ADMINISTRATOR, FINTECH, DIRECTOR, MANAGER, FINANCE],
        disabledBillingPeriodType: RECURRING,
        to: (clientId) => `/dashboard/clients/${clientId}/synchronizations`,
        title: "clients.client.pages.synchronizations",
      },
      {
        exactRole: INTERNAL_ROLES,
        disabledBillingPeriodType: MANUAL,
        requiresMintEnabled: true,
        disabledSyncType: [TED_DESJARDINS],
        to: (clientId) => `/dashboard/clients/${clientId}/member-files`,
        title: "clients.client.pages.memberFiles",
      },
      {
        exactRole: MENROL_ELIGIBLE_ROLES,
        exactClientStatusType: [ACTIVE, IMPLEMENTATION, INACTIVE],
        includeArchivedClient: false,
        requiresMenrolEnabled: true,
        to: (clientId) => `${buildMENROLFrontendURL()}admin/enrolments?msys_client_id=${clientId}`,
        isExternal: true,
        title: "clients.client.pages.majorEnrolment",
        showIcon: true,
      },
    ];
    return menus;
  }

  render() {
    const { clientId, clientBillingPeriodType, isMintEnabled, client } = this.props;
    const menus = this.getMenus();

    return (
      <div className="sub-nav">
        <ul>
          {menus
            .filter((menu) =>
              this.renderMenu(
                menu,
                clientBillingPeriodType,
                menu.shouldRender ? menu.shouldRender(client) : () => true,
                isMintEnabled
              )
            )
            .map((menu, index) => {
              if (menu.isExternal) {
                return (
                  <li key={index}>
                    <a href={menu.to(clientId)} target="_blank" activeClassName="active">
                      <FormattedMessage id={menu.title} />
                      {menu.showIcon && (
                        <span className="icon icon-new-tab" />
                      )}
                      {!!menu.count && <span>({menu.count})</span>}
                    </a>
                  </li>
                );
              }
              return (
                <li key={index}>
                  <Link to={menu.to(clientId)} activeClassName="active">
                    <FormattedMessage id={menu.title} />
                    {!!menu.count && <span>({menu.count})</span>}
                  </Link>
                </li>
              );
            })}
        </ul>
      </div>
    );
  }
}

ClientNav.propTypes = {
  client: PropTypes.object,
  clientAttachmentsCount: PropTypes.number,
  clientBillingPeriodType: PropTypes.string,
  clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isMintEnabled: PropTypes.bool,
  isMenrolEnabled: PropTypes.bool,
  auth: PropTypes.object.isRequired,
};

export default ClientNav;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/ClientNav.js